import { useState } from "react";

interface Toast {
  title: string;
  description?: string;
  variant?: "default" | "destructive";
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const toast = (toastData: Toast) => {
    // For demo purposes, just log the toast
    // In a real app, this would show a toast notification
  };

  return {
    toast,
    toasts
  };
}